import { takeLatest, put, select } from 'redux-saga/effects';
import { createAxios, logNative, sortSoftsByLocalSoftInit } from '../utils/utils';
import { cacheKeys } from '../constants/storageKeys';
import {
  SEARCH_COURSE_83,
  SEARCH_POST_83,
  SEARCH_WALLPAPER_83,
  SEARCH_APP_83,
  WP_RECOMMEND_IMG_60,
  FORUM_HOT_LIST_83,
  EDUCATION_HOT_LIST_83,
} from '../config';
import {
  SEARCH_APP_REQUEST,
  SEARCH_APP_SUCCESS,
  SEARCH_WALLPAPER_REQUEST,
  SEARCH_WALLPAPER_SUCCESS,
  SEARCH_POST_REQUEST,
  SEARCH_POST_SUCCESS,
  SEARCH_COURSE_REQUEST,
  SEARCH_COURSE_SUCCESS,
  UPDATE_SEARCH_COUNT,
  SEARCH_WALLPAPER_HOT_REQUEST,
  SEARCH_POST_HOT_REQUEST,
  SEARCH_COURSE_HOT_REQUEST,
  SEARCH_WALLPAPER_HOT_SUCCESS,
  SEARCH_POST_HOT_SUCCESS,
  SEARCH_COURSE_HOT_SUCCESS,
} from '../constants/searchResult';
import Toast from '../components/Toast/Toast';

// 软件搜索
function* fetchGetSearchApp({ payload }) {
  const searchApp = yield select(state => state.searchResult.searchApp);
  const searchParam = yield select(state => state.searchResult.searchParam);
  const searchCount = yield select(state => state.searchResult.searchCount);
  let defPayload = {
    bizInfo: '',
    algoBizInfo: '',
    dataList: [],
    loading: 200,
    searchParam,
  };

  const params = {
    searchWord: payload.searchWord, // 搜索词
    searchMode: payload.searchMode || searchParam.searchMode, // 0-搜索框搜索，1-有筛选条件搜索
    tab: '0', // 搜索类型，0-应用，1-壁纸，2-文章，3-课程
    skip: '0',
    limit: '30',
    algoBizInfo: payload.algoBizInfo || '', // 算法信息字段
    firstId: payload.firstId || '', // 搜索来自联想词首位词时，需带上应用id
    androidType: payload.androidType || '0', // 搜索来自联想词首位词时，需带上应用类型
    type: payload.sortTypeSel || '0', // 应用平台类型，0-应用平台，1-PC应用，2-安卓应用
    category: payload.softCategorySel || '0', // 应用分类类型，0-应用类别，1-游戏，2-软件
    serviceBizInfo: payload?.serviceBizInfo ?? '', //透传的serviceBizInfo
  };

  yield put({
    type: SEARCH_APP_SUCCESS,
    payload: {
      loading: 1,
      searchParam,
    },
  });

  const axios = yield createAxios('isNeedUser');
  const res = yield axios.get(SEARCH_APP_83, { params });
  try {
    if (res?.status === 200 && res?.data?.status === 0 && res?.data?.data) {
      yield put({
        type: SEARCH_APP_SUCCESS,
        payload: {
          ...res?.data?.data,
          dataList: res?.data?.data?.dataList || [],
          loading: 200,
          searchParam,
        },
      });

      // 去更新获取的总条数
      let count = res?.data?.data?.count;
      if (count) {
        let payloadCount = { ...searchCount };
        if (params.searchMode === '0') {
          payloadCount = count;
        }
        payloadCount.appsCount = count?.appsCount || 0;
        yield put({
          type: UPDATE_SEARCH_COUNT,
          payload: payloadCount,
        });
      }
    } else {
      // 请求数据失败
      yield put({
        type: SEARCH_APP_SUCCESS,
        payload: { ...defPayload, loading: 199 },
      });
    }
  } catch (err) {
    // 请求数据错误
    yield put({
      type: SEARCH_APP_SUCCESS,
      payload: { ...defPayload, loading: 199 },
    });
  }
}
export function* watchGetSearchApp() {
  yield takeLatest(SEARCH_APP_REQUEST, fetchGetSearchApp);
}

// 壁纸搜索
function* fetchGetSearchWallpaper({ payload }) {
  const searchWallpaper = yield select(state => state.searchResult.searchWallpaper);
  const searchParam = yield select(state => state.searchResult.searchParam);
  const searchCount = yield select(state => state.searchResult.searchCount);
  let defPayload = {
    bizInfo: '',
    algoBizInfo: '',
    dataList: [],
    loading: 200,
    searchParam,
  };
  let params = {
    searchWord: payload.searchWord, // 搜索词
    searchMode: payload.searchMode || searchParam.searchMode, // 0-搜索框搜索，1-有筛选条件搜索
    tab: '1', // 搜索类型，0-应用，1-壁纸，2-文章，3-课程
    skip: '0',
    limit: '48',
    algoBizInfo: payload.algoBizInfo || '', // 算法信息字段
    // dpi: payload.wallpaperDpiSel || '0',, // 分辨率，0-分辨率，1-1080P，2-2K，3-4K
    pay: payload.wallpaperPaySel || '0', // 应用平台类型，0-应用平台，1-PC应用，2-安卓应用
  };

  // loadmore
  if (payload.refresh) {
    yield put({
      type: SEARCH_WALLPAPER_SUCCESS,
      payload: {
        loading: 1,
        searchParam,
      },
    });
  } else {
    if (searchWallpaper?.dataList?.length > 0) {
      params.skip = searchWallpaper?.dataList?.length;
    }
  }

  const axios = yield createAxios('isNeedUser');
  const res = yield axios.get(SEARCH_WALLPAPER_83, {
    params: params,
  });
  try {
    if (res?.status === 200 && res?.data?.status === 0 && res?.data?.data) {
      if (payload.refresh) {
        yield put({
          type: SEARCH_WALLPAPER_SUCCESS,
          payload: {
            ...res?.data?.data,
            dataList: res?.data?.data?.dataList || [],
            loading: 200,
            searchParam,
          },
        });

        // 去更新获取的总条数
        let count = res?.data?.data?.count;
        if (count) {
          let payloadCount = { ...searchCount };
          if (params.searchMode === '0') {
            payloadCount = count;
          }
          payloadCount.wallpapersCount = count?.wallpapersCount || 0;
          yield put({
            type: UPDATE_SEARCH_COUNT,
            payload: payloadCount,
          });
        }
      } else {
        let dataList = [...(searchWallpaper?.dataList || []), ...(res?.data?.data?.dataList || [])];
        yield put({
          type: SEARCH_WALLPAPER_SUCCESS,
          payload: {
            ...res?.data?.data,
            dataList,
            loading: 200,
            searchParam,
            bizInfo: searchWallpaper?.bizInfo,
          },
        });
      }
    } else {
      yield put({ type: SEARCH_WALLPAPER_SUCCESS, payload: { ...defPayload, loading: 199 } });
    }
  } catch (err) {
    yield put({ type: SEARCH_WALLPAPER_SUCCESS, payload: { ...defPayload, loading: 199 } });
  }
}
export function* watchGetSearchWallpaper() {
  yield takeLatest(SEARCH_WALLPAPER_REQUEST, fetchGetSearchWallpaper);
}

// 文章搜索
function* fetchGetSearchPost({ payload }) {
  const searchPost = yield select(state => state.searchResult.searchPost);
  const searchParam = yield select(state => state.searchResult.searchParam);
  const searchCount = yield select(state => state.searchResult.searchCount);
  let defPayload = {
    bizInfo: '',
    algoBizInfo: '',
    dataList: [],
    loading: 200,
    searchParam,
  };
  let params = {
    searchWord: payload.searchWord, // 搜索词
    searchMode: payload.searchMode || searchParam.searchMode, // 0-搜索框搜索，1-有筛选条件搜索
    tab: '2', // 搜索类型，0-应用，1-壁纸，2-文章，3-课程
    skip: '0',
    limit: '48',
    algoBizInfo: payload.algoBizInfo || '', // 算法信息字段
    type: payload.postTypeSel || '0', // 应用平台类型，0-应用平台，1-PC应用，2-安卓应用
  };

  // loadmore
  if (payload.refresh) {
    yield put({
      type: SEARCH_POST_SUCCESS,
      payload: {
        loading: 1,
        searchParam,
      },
    });
  } else {
    if (searchPost?.dataList?.length > 0) {
      params.skip = searchPost?.dataList?.length;
    }
  }

  const axios = yield createAxios('isNeedUser');
  const res = yield axios.get(SEARCH_POST_83, {
    params: params,
  });
  try {
    if (res?.status === 200 && res?.data?.status === 0 && res?.data?.data) {
      if (payload.refresh) {
        yield put({
          type: SEARCH_POST_SUCCESS,
          payload: {
            ...res?.data?.data,
            dataList: res?.data?.data?.dataList || [],
            loading: 200,
            searchParam,
          },
        });

        // 去更新获取的总条数
        let count = res?.data?.data?.count;
        if (count) {
          let payloadCount = { ...searchCount };
          if (params.searchMode === '0') {
            payloadCount = count;
          }
          payloadCount.postsCount = count?.postsCount || 0;
          yield put({
            type: UPDATE_SEARCH_COUNT,
            payload: payloadCount,
          });
        }
      } else {
        let dataList = [...(searchPost?.dataList || []), ...(res?.data?.data?.dataList || [])];
        yield put({
          type: SEARCH_POST_SUCCESS,
          payload: {
            ...res?.data?.data,
            dataList,
            loading: 200,
            searchParam,
            bizInfo: searchPost?.bizInfo,
          },
        });
      }
    } else {
      yield put({ type: SEARCH_POST_SUCCESS, payload: { ...defPayload, loading: 199 } });
    }
  } catch (err) {
    yield put({ type: SEARCH_POST_SUCCESS, payload: { ...defPayload, loading: 199 } });
  }
}
export function* watchGetSearchPost() {
  yield takeLatest(SEARCH_POST_REQUEST, fetchGetSearchPost);
}

// 搜索课程
function* fetchGetSearchCourse({ payload }) {
  const searchCourse = yield select(state => state.searchResult.searchCourse);
  const searchParam = yield select(state => state.searchResult.searchParam);
  const searchCount = yield select(state => state.searchResult.searchCount);
  let defPayload = {
    bizInfo: '',
    algoBizInfo: '',
    dataList: [],
    loading: 200,
    searchParam,
  };
  let params = {
    searchWord: payload.searchWord, // 搜索词
    searchMode: payload.searchMode || searchParam.searchMode, // 0-搜索框搜索，1-有筛选条件搜索
    tab: '3', // 搜索类型，0-应用，1-壁纸，2-文章，3-课程
    skip: '0',
    limit: '48',
    algoBizInfo: payload.algoBizInfo || '', // 算法信息字段
    pay: payload.coursePaySel || '0', // 应用平台类型，0-应用平台，1-PC应用，2-安卓应用
  };

  // loadmore
  if (payload.refresh) {
    yield put({
      type: SEARCH_COURSE_SUCCESS,
      payload: {
        loading: 1,
        searchParam,
      },
    });
  } else {
    if (searchCourse?.dataList?.length > 0) {
      params.skip = searchCourse?.dataList?.length;
    }
  }

  const axios = yield createAxios('isNeedUser');
  const res = yield axios.get(SEARCH_COURSE_83, {
    params: params,
  });
  try {
    if (res?.status === 200 && res?.data?.status === 0 && res?.data?.data) {
      if (payload.refresh) {
        yield put({
          type: SEARCH_COURSE_SUCCESS,
          payload: {
            ...res?.data?.data,
            dataList: res?.data?.data?.dataList || [],
            loading: 200,
            searchParam,
          },
        });

        // 去更新获取的总条数
        let count = res?.data?.data?.count;
        if (count) {
          let payloadCount = { ...searchCount };
          if (params.searchMode === '0') {
            payloadCount = { ...count };
          }
          payloadCount.coursesCount = count?.coursesCount || 0;
          yield put({
            type: UPDATE_SEARCH_COUNT,
            payload: payloadCount,
          });
        }
      } else {
        let dataList = [...(searchCourse?.dataList || []), ...(res?.data?.data?.dataList || [])];
        yield put({
          type: SEARCH_COURSE_SUCCESS,
          payload: {
            ...res?.data?.data,
            dataList,
            loading: 200,
            searchParam,
            bizInfo: searchCourse?.bizInfo,
          },
        });
      }
    } else {
      yield put({ type: SEARCH_COURSE_SUCCESS, payload: { ...defPayload, loading: 199 } });
    }
  } catch (err) {
    yield put({ type: SEARCH_COURSE_SUCCESS, payload: { ...defPayload, loading: 199 } });
  }
}
export function* watchGetSearchCourse() {
  yield takeLatest(SEARCH_COURSE_REQUEST, fetchGetSearchCourse);
}

// 壁纸推荐
function* fetchGetSearchWallpaperHot({ payload }) {
  const axios = yield createAxios('isNeedUser');
  const res = yield axios.get(WP_RECOMMEND_IMG_60, {
    params: {
      skip: 0,
      limit: 48,
    },
  });
  try {
    if (res?.data?.status === 0 && res?.data?.data) {
      yield put({
        type: SEARCH_WALLPAPER_HOT_SUCCESS,
        payload: { ...res.data.data },
      });
    }
  } catch (err) {
    logNative(`搜索，请求热门壁纸数据失败 ${err}`);
  }
}
export function* watchGetSearchWallpaperHot() {
  yield takeLatest(SEARCH_WALLPAPER_HOT_REQUEST, fetchGetSearchWallpaperHot);
}

// 文章推荐
function* fetchGetSearchPostHot({ payload }) {
  const axios = yield createAxios('isNeedUser');
  const res = yield axios.get(FORUM_HOT_LIST_83, {
    params: {
      channel: '1',
      skip: 0,
      limit: 48,
    },
  });
  try {
    if (res?.data?.status === 0 && res?.data?.data) {
      yield put({
        type: SEARCH_POST_HOT_SUCCESS,
        payload: { ...res.data },
      });
    }
  } catch (err) {
    logNative(`搜索，请求热门文章数据失败 ${err}`);
  }
}
export function* watchGetSearchPostHot() {
  yield takeLatest(SEARCH_POST_HOT_REQUEST, fetchGetSearchPostHot);
}

// 课程推荐
function* fetchGetSearchCourseHot({ payload }) {
  const axios = yield createAxios('isNeedUser');
  const res = yield axios.get(EDUCATION_HOT_LIST_83, {
    params: {
      productCode: '2',
      skip: 0,
      limit: 48,
    },
  });
  try {
    if (res?.data?.status === 0 && res?.data?.data) {
      yield put({
        type: SEARCH_COURSE_HOT_SUCCESS,
        payload: { ...res.data },
      });
    }
  } catch (err) {
    logNative(`搜索，请求热门文章数据失败 ${err}`);
  }
}
export function* watchGetSearchCourseHot() {
  yield takeLatest(SEARCH_COURSE_HOT_REQUEST, fetchGetSearchCourseHot);
}
